export const HTML_BREAKLINE = '<br>'

export const HTML_BR_REPLACEMENT = '<p>&nbsp;</p>'

export const HTML_ELEMENT_TAB_INDEX_NOT_TABABLE = -1

export const HTML_ELEMENT_TAB_INDEX_TABABLE = 0

export const HTML_ELEMENT_PAGE_SCROLL_WRAPPER_ID = 'cover'

export const HTML_ELEMENT_THEME_PROVIDER_ID = 'theme-provider'

export const HTML_LINK_TARGET = {
  blank: '_blank',
  parent: '_parent',
  self: '_self',
  top: '_top',
}

export const HTML_MIME_TYPE = 'text/html'

// Fail-safe cap on text nodes processed when walking parsed HTML.
export const HTML_MAX_TEXT_NODES = 20000

export const HTML_DATA_SEPARATOR = '-'

export const HTML_DATA_PREFIX = `data${HTML_DATA_SEPARATOR}`

export const HTML_OPERATOR_EQUALS = '='

export const HTML_OPERATOR_STARTS_WITH = '^='

export const HTML_DATA_PARAM_OUTSIDE_TRIGGER =
  HTML_DATA_PREFIX + 'outside-trigger'

export const HTML_DATA_PARAM_EMPTY_LINE = HTML_DATA_PREFIX + 'empty-line'

export const HTML_DATA_PARAM_FILE_PREVIEW_OPEN =
  HTML_DATA_PREFIX + 'file-preview-open'

export const HTML_LINK_PROTOCOL_TEL = 'tel:'

export const HTML_LINK_PROTOCOL_HTTP = 'http:'

export const HTML_LINK_PROTOCOL_HTTPS = 'https:'

export const HTML_LINK_PROTOCOL_MAILTO = 'mailto:'
